<template>
    <div>
        <Logo />
        <div class="row justify-content-center">
            <div class="col-11 col-xs-11 col-md-6">
                <div class="u-form">
                    <ion-label>Your Name</ion-label>
                    <ion-input placeholder="Name" type="text" shape="round" expand="full" v-on:ionInput="setName($event)" style='background:var(--ion-color-light); border-radius: 20px; margin-bottom: 12px; text-align: left; --padding-start: 20px'></ion-input>
                    <div class="form-error" v-if="errors.name">{{errors.name}}</div>

                    <ion-label>Your Email Address</ion-label>
                    <ion-input placeholder="Email" type="email" shape="round" expand="full" v-on:ionInput="setEmail($event)" style='background:var(--ion-color-light); border-radius: 20px; margin-bottom: 12px; text-align: left; --padding-start: 20px'></ion-input>
                    <div class="form-error" v-if="errors.email">{{errors.email}}</div>

                    <ion-label>Your Password</ion-label>
                    <ion-input placeholder="Password" type="password" shape="round" expand="full" v-on:ionInput="setPassword($event)" style='background:var(--ion-color-light); border-radius: 20px; margin-bottom: 12px; text-align: left; --padding-start: 20px'></ion-input>
                    <ion-input placeholder="Password (confirm)" type="password" shape="round" expand="full" v-on:ionInput="setPassword2($event)" style='background:var(--ion-color-light); border-radius: 20px; margin-bottom: 12px; text-align: left; --padding-start: 20px'></ion-input>
                    <div class="form-error" v-if="errors.password">{{errors.password}}</div>


                    <ion-item lines="none">
                        <ion-checkbox slot="start" v-on:input="setPrivacy($event)" value="true"></ion-checkbox>
                        <ion-label class="privacy">Accept Privacy Policy</ion-label>
                    </ion-item>
                    <div :class="errors.privacy ? 'form-error' : 'form-info'">
                        By creating an account you must agree to the terms of our
                        <a href="https://app.ghostapp.co.uk/policy.pdf" target="_blank">Privacy Policy</a>
                    </div>
                    <br>

                    <div class="u-mt1 text-center" v-if="posting">
                        <i class="fas fa-circle-notch fa-spin fa-3x"></i>
                    </div>
                    <div v-else>
                        <ion-button shape="round" expand="full" v-on:click="register()">Register for a free account</ion-button>
                    </div>
                </div>
                <div class="router-nav">
                    <router-link to="/login">Login</router-link> |
                    <router-link to="/password">Forgot Password</router-link> |
                    <a href="https://app.ghostapp.co.uk/policy.pdf" target="_blank">Privacy Policy</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from 'lodash';
import Logo from '@/components/Logo.vue'
import {alerts} from '../../mixins/alerts';
import {registration} from '../../mixins/registration';
export default {
    name: 'register',
    data : function () {
        return {
            email        : '',
            password     : '',
            password2    : '',
            privacy      : false,
            name         : '',
            errors       : {},
            posting      : false
        }
    },
    mixins : [alerts, registration],
    mounted : function () {
        //
    },
    components: {
        Logo
    },
    computed : {
        canRegister : function () {
            if (_.trim(this.name) == '') {
                return false;
            }
            if (_.trim(this.email) == '') {
                return false;
            }
            if (this.password != this.password2) {
                return false;
            }
            if (_.size(this.password) < 7) {
                return false;
            }
            if (!this.validateEmail(this.email)) {
                return false;
            }
            if (!this.privacy) {
                return false;
            }
            return true;
        }
    },
    methods : {
        validateEmail : function (email) {
            if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,12})+$/.test(email)) {
                return true;
            }
            return false;
        },
        setEmail : function (event) {
            this.email = event.target.value;
        },
        setName : function (event) {
            this.name = event.target.value;
        },
        setPassword : function (event) {
            this.password = event.target.value;
        },
        setPassword2 : function (event) {
            this.password2 = event.target.value;
        },
        setPrivacy : function (event) {
            console.log('checked', event.target.checked);
            // odd, but it looks like event.target.checked is in reverse.
            this.privacy = !event.target.checked;
        },
        validate : function () {
            let errors = {}
            if (_.trim(this.name) == '') {
                errors.name = 'Please provide your name';
            }
            if (_.trim(this.email) == '') {
                errors.email = 'Please provide an email';
            } else if (!this.validateEmail(this.email)) {
                errors.email = 'Please provide a valid email';
            }
            if (_.trim(this.password) == '') {
                errors.password = 'Please provide a password';
            } else if (_.size(this.password) < 7) {
                errors.password = 'Your password should be at least 7 characters';
            } else if (this.password != this.password2) {
                errors.password = 'Your passwords do not match';
            }
            if (!this.privacy) {
                errors.privacy = 'Please accept the privacy policy';
            }
            this.errors = errors;
            return _.size(this.errors) == 0;
        },
        register : function () {
            let self = this;
            this.posting = true;
            if (!this.validate()) {
                this.posting = false;
                self.showError("Please check the information you provided and try again");
                return;
            }
            let params = {
                name                  : self.name,
                email                 : self.email,
                password              : self.password,
                password_confirmation : self.password2
            };
            self.axios.post(self.api + 'auth/register', params)
                .then(response => {
                    // show a success message
                    self.showSuccess('Thanks for registering!', function () {
                        self.login({email : self.email, password : self.password});
                    });
                    // the callback should log them in
                    self.posting = false;
                })
                .catch(error => {
                    var msg = 'There was a problem processing that request. Please check the details you provided.';
                    if (error.response && error.response.data && error.response.data.error) {
                        msg = error.response.data.error;
                    }
                    self.showError(msg);
                    self.posting = false;
                });
        },
        getUserDetails : function () {
            let self = this;
            this.axios.post(this.api + 'auth/me')
                .then(response => {
                    // console.debug('Retrieved User Details', response.data);
                    self.$root.setUser(response.data);
                    self.$router.push({ name : 'home' });
                })
                .catch(error => {
                    // if there's an error, bounce to login page
                    console.error('ERROR getting user details', error);
                    self.$router.push({name : 'login'});
                });
        },
        login : function () {
            let self = this,
                params = {
                    email : this.email,
                    password : this.password
                };
            this.axios.post(this.api + 'auth/login', params)
                .then(response => {
                    // console.log('login', response.data);
                    self.$root.setUserToken(response.data.access_token);
                    self.getUserDetails();
                })
                .catch(error => {
                    console.error('ERROR logging in', error);
                    // if there's an error, bounce to login page
                    self.$router.push({name : 'login'});
                });
        },
        openPrivacyPolicy : function () {
            window.open('policy.pdf', '_blank', 'fullscreen=yes')
        }
    }
}
</script>

<style>
.help-text {
    color : var(--ion-color-medium);
    font-weight : 100;
    text-align : left;
}
.help-text.-strong {
    font-weight : 600;
    color : var(--ion-color-dark);
}
.router-nav a {
    color : var(--ion-color-dark);
}
</style>